import * as React from 'react';

const NonCardAnchorWrapper = ({ children, href }) => {
    return (
        <div
            className={`relative h-full w-full overflow-hidden transition-all rounded-8 hover:bg-aqua-50 p-8`}
        >
            <div aria-owns="title" />
            <h3 id="title" className={'m-0'}>
                <a
                    className="link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring"
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                >
                    {children}
                </a>
            </h3>
        </div>
    );
};

export default NonCardAnchorWrapper;
